<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:30px;font-weight:bold;">1、MAC上MOA版本查看</span><br><br>
    <p>双击菜单栏的MOA图标打开MOA：</p>
    <p><img src="../../assets/moaVersionView/moaVersionView_pic03.png" width=480px height=170px></p>
    <p>「帮助」-->「版本更新」-->「更新版本」</p>
    <p><img src="../../assets/moaVersionView/moaVersionView_pic01.png" width=940px height=500px></p>
    <span style="font-size:30px;font-weight:bold;">2、Windows上MOA版本查看</span><br><br>
    <p>双击菜单栏中已运行的MOA图标打开MOA：</p>
    <p><img src="../../assets/moaVersionView/moaVersionView_pic04.png" width=480px height=170px></p>
    <p>查看版本信息：</p>
    <p><img src="../../assets/moaVersionView/moaVersionView_pic02.png" width=940px height=500px></p>
    <h1 style="font-size:30px;font-weight:bold;">3、如果无法打开MOA，或者更新不到最新版本</h1>
    <p>如果无法打开MOA或者更新不到最新版本，请直接按照安装指导，下载最新版MOA覆盖安装即可。</p>
    </div>
  </div>
</template>

<script>
  import store from '../../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// moaVersionView.vue?2276c144